import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-background py-16 sm:py-20" aria-labelledby="results-title" data-id="element-130" data-mp="28eg99jwmki7p">
      <div className="mx-auto max-w-6xl px-4" data-id="element-131" data-mp="2d6zun31k0hn2">
        <SectionHeading id="results-title" data-id="element-132" data-mp="2d7rifrowtb2s">What <span className="text-accent" data-id="element-133" data-mp="2h8bbok6d3ujn">professionals</span> say</SectionHeading>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-134" data-mp="2m6cx3br9g5ya">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-primary/50 bg-surface p-6 shadow-lg shadow-black/30" data-id="element-135" data-mp="2r5g3p0mw2k8d" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-accent" aria-hidden="true" data-id="element-136" data-mp="3nf0pwxl2ir0i" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-137" data-mp="3iloddltnyao4">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-primary/20 pt-4" data-id="element-138" data-mp="3doeg5k018upq">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-primary/40 bg-background text-sm font-extrabold text-primary" data-id="element-139" data-mp="38pkzxjtd2plv">
                  {initials}
                </span>
                <span data-id="element-140" data-mp="58mcr0umil36">
                  <b className="block text-sm text-foreground" data-id="element-141" data-mp="5608pb6xynpp">{name}</b>
                  <small className="text-xs text-muted" data-id="element-142" data-mp="6wzrfnubxcg">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}